import { FC, useContext, useEffect, useState } from 'react'
import { Box, Button, Typography, useTheme } from '@mui/material'
import NodeHandle from '../../components/shared/Handle'
import { PlaybookContext } from '../../contexts/playbooks.context'
import { updateNode } from '../../services/node.service'
import GamepadIcon from '@mui/icons-material/Gamepad'

import styles from './styles.module.scss'

interface IProps {
  data: {
    state: string
    nodeId: number
  }
}

const ButtonsNode: FC<IProps> = ({ data }) => {
  const theme = useTheme()

  const [isHighlighted, setIsHighlighted] = useState(false)

  const { reactFlowNodes, playbook } = useContext(PlaybookContext)

  const onClick = async (state: string) => {
    if (playbook && playbook.status === 'running') {
      const node = playbook.nodes.find((node) => +node.id === data.nodeId)

      if (node) {
        await updateNode({
          ...node,
          data: { ...node.data, state },
        })
      }
    }
  }

  useEffect(() => {
    const node = reactFlowNodes.find(
      (node) => node.selected && +node.id === data.nodeId,
    )

    if (node) {
      setIsHighlighted(true)
    } else {
      setIsHighlighted(false)
    }
  }, [reactFlowNodes, data.nodeId])

  const style: React.CSSProperties = {
    backgroundColor: theme.palette.elevated.main,
    border: '2px solid ' + theme.palette.elevated.dark,
  }

  if (isHighlighted) {
    Object.assign(style, {
      boxShadow: '0 0 10px ' + theme.palette.text.primary,
    })
  }

  return (
    <div className={styles.node} id={`${data.nodeId}`} style={style}>
      <div className={styles.content}>
        {playbook?.status !== 'running' && (
          <GamepadIcon
            sx={{ color: theme.palette.warning.light, width: 40, height: 40 }}
          />
        )}
        {playbook?.status !== 'running' && (
          <Typography id="nodeIdentifier" className={styles.text}>
            Manual Review
          </Typography>
        )}
        {playbook && <NodeHandle direction={playbook.direction} />}

        {playbook?.status === 'running' && (
          <Box className={styles.buttonsContainer} id="nodeIdentifier">
            <Button
              id="allowButton"
              onClick={() => onClick('allow')}
              sx={{
                color: theme.palette.success.contrastText,
                background: theme.palette.success.main,
              }}
              className={styles.button}
            >
              Allow
            </Button>
            <Button
              id="denyButton"
              onClick={() => onClick('deny')}
              sx={{
                color: theme.palette.error.contrastText,
                background: theme.palette.error.main,
              }}
              className={styles.button}
            >
              Deny
            </Button>
          </Box>
        )}
      </div>
    </div>
  )
}

export default ButtonsNode
